/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Withdraw_DescInputs */

const en_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Withdraw consent for analytics at any time`)
};

const de_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) -- Widerrufen Sie Ihre Einwilligung für Analysen jederzeit`)
};

const fr_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) -- Retirer votre consentement pour les analyses à tout moment`)
};

const es_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) -- Retirar su consentimiento para análisis en cualquier momento`)
};

const it_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Revocare il consenso per le analisi in qualsiasi momento`)
};

const nl_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Toestemming voor analytics op elk moment intrekken`)
};

const pl_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Cofnięcie zgody na analizy w dowolnym momencie`)
};

const fi_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 7(3)) — Peruuta analytiikan suostumus milloin tahansa`)
};

const da_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Træk samtykke til analyse tilbage når som helst`)
};

const sv_privacy_rights_item_withdraw_desc = /** @type {(inputs: Privacy_Rights_Item_Withdraw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 7(3)) — Återkalla samtycke för analys när som helst`)
};

/**
* | output |
* | --- |
* | "(Art. 7(3)) — Withdraw consent for analytics at any time" |
*
* @param {Privacy_Rights_Item_Withdraw_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_withdraw_desc = /** @type {((inputs?: Privacy_Rights_Item_Withdraw_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Withdraw_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_withdraw_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_withdraw_desc(inputs)
	return en_privacy_rights_item_withdraw_desc(inputs)
});